import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });
client.interceptors.request.use((cfg) => {
  const w = localStorage.getItem("ws_id");
  if (w) cfg.headers["X-Workspace-Id"] = w;
  return cfg;
});

export const api = {
  // auth
  register: (p) => client.post("/auth/register", p),
  login: (p) => client.post("/auth/login", p),
  setPassword: (token, password) => client.post("/auth/set-password", { token, password }),
  verify2fa: (temp_token, code) => client.post("/auth/2fa/verify", { temp_token, code }),
  me: () => client.get("/auth/me"),
  logout: () => client.post("/auth/logout"),
  setup2fa: () => client.post("/auth/2fa/setup"),
  enable2fa: (code) => client.post("/auth/2fa/enable", { code }),
  disable2fa: (code) => client.post("/auth/2fa/disable", { code }),
  verifyEmail: (token) => client.post("/auth/verify-email", { token }),
  resendVerification: () => client.post("/auth/resend-verification"),
  // workspaces
  listWorkspaces: () => client.get("/workspaces"),
  createWorkspace: (p) => client.post("/workspaces", p),
  updateWorkspace: (id, p) => client.put(`/workspaces/${id}`, p),
  deleteWorkspace: (id) => client.delete(`/workspaces/${id}`),
  // seo
  runAudit: (url, max_pages = 6) => client.post("/audit/run", { url, max_pages }),
  listAudits: () => client.get("/audit/list"),
  getAudit: (id) => client.get(`/audit/${id}`),
  genContent: (p) => client.post("/content/generate", p),
  listContent: () => client.get("/content/list"),
  publishContent: (id, publish = false) => client.post(`/content/${id}/publish`, { publish }),
  publishContentShopify: (id, publish = false) => client.post(`/content/${id}/publish-shopify`, { publish }),
  listShopifyBlogs: (wid) => client.get(`/workspaces/${wid}/shopify/blogs`),
  localSeo: () => client.post("/local-seo/generate"),
  auditTrend: () => client.get("/audit/trend"),
  // crm
  listLeads: () => client.get("/leads"),
  createLead: (p) => client.post("/leads", p),
  updateStage: (id, stage) => client.put(`/leads/${id}/stage`, { stage }),
  deleteLead: (id) => client.delete(`/leads/${id}`),
  draftEmail: (id, goal) => client.post(`/leads/${id}/email`, { goal }),
  report: () => client.get("/reports/pipeline"),
  zohoSync: (id) => client.post(`/zoho/sync/${id}`),
  // gsc
  gscStatus: () => client.get("/gsc/status"),
  gscAuthUrl: () => client.get("/gsc/auth-url"),
  gscSites: () => client.get("/gsc/sites"),
  gscSelectSite: (site_url) => client.post("/gsc/select-site", { site_url }),
  gscRankings: (days, dimension) => client.post("/gsc/rankings", { days, dimension }),
  gscTrend: () => client.get("/gsc/trend"),
  // portfolio (cross-workspace, not scoped to a single workspace header)
  portfolio: () => client.get("/portfolio"),
  // billing
  billingStatus: () => client.get("/billing/status"),
  billingCheckout: (price_id, success_url, cancel_url) =>
    client.post("/billing/checkout", { price_id, success_url, cancel_url }),
  confirmCheckout: (session_id) => client.post("/billing/confirm", { session_id }),
  // competitors
  listCompetitors: () => client.get("/competitors"),
  analyzeCompetitor: (domain) => client.post("/competitors/analyze", { domain }),
  deleteCompetitor: (id) => client.delete(`/competitors/${id}`),
  // outreach / link building
  outreachConfig: () => client.get("/outreach/config"),
  listOutreach: () => client.get("/outreach"),
  generateProspects: (count, focus) => client.post("/outreach/generate", { count, focus }),
  updateOutreach: (id, p) => client.put(`/outreach/${id}`, p),
  deleteOutreach: (id) => client.delete(`/outreach/${id}`),
  draftOutreach: (id) => client.post(`/outreach/${id}/draft`),
  sendOutreach: (id) => client.post(`/outreach/${id}/send`),
};

export function apiError(e, fallback = "Something went wrong") {
  const d = e.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return d?.msg || e.message || fallback;
}
